import { useState } from 'react';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  approachingLimit: boolean;
  onNewChat: () => void;
}

/**
 * Dismissible "this conversation is getting long" banner (§7.3). Dismissal
 * is not persisted beyond the current mount — matches the lightweight,
 * no-new-infra spirit of the rest of this phase. Compression (§7.2) is
 * already keeping the session functional past this point; this is purely a
 * UX nudge, not a hard requirement.
 */
export function AIChatLimitBanner({ approachingLimit, onNewChat }: Props) {
  const [dismissed, setDismissed] = useState(false);

  if (!approachingLimit || dismissed) return null;

  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{ mx: 1.5, mb: 1, py: 0, fontSize: 12.5 }}
      action={
        <IconButton size="small" onClick={() => setDismissed(true)}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
    >
      This conversation is getting long —{' '}
      <a href="#" onClick={(e) => { e.preventDefault(); onNewChat(); }}>
        start a new one?
      </a>
    </Alert>
  );
}
